import { Component, OnInit,ViewChildren,QueryList, ViewChild} from '@angular/core';
import { MatPaginator, MatTableDataSource , MatSort } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';        
import { style } from '@angular/animations';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CryptoJS from 'crypto-js';
import { saveAs as importedSaveAs } from "file-saver";
import { Router, ActivatedRoute } from '@angular/router';




const now = new Date()
const time_today = now.getTime()
const formatTime = formatDate(time_today,'HH:mm','en-US','+0530')
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530')
console.log("formatTime -- : ",formatTime) 
//console.log("datecur :",  currentdat)
export interface DialogData {
setValue :string,
setRole : string
}
@Component({
  selector: 'app-ttlusers-summary',
  templateUrl: './ttlusers-summary.component.html',
  styleUrls: ['./ttlusers-summary.component.css']
})
export class  TtlusersSummaryComponent implements OnInit {
  maxDate: Date = new Date();

  deactvResult: any;
  fileDownload: any = [];
  entity: any = [];
  entitySummary: any = [];
  modelTest: any;
  entityId: any;
  filterData:any;
  dataSource: MatTableDataSource<any>; 
  dataSource1: MatTableDataSource<any>;
  dataSource2: MatTableDataSource<any>;
  noRecord: any;
  noRecord1: any;
  noRecord2: any;
  refNos= "";
  ttlids= "";
  Ttsl_EmailID:any;
  sts: any;  
  ProcessRole :any;
  ObjectKeys:any;
  fetchedData:any;
  selectedValue:any="Process";  

  data:any= {
    
    "ProcessRole": this.db.get(Constants.SESSSION_STORAGE, Constants.Ttsl_ProcessRole),
    "status":"C",
   // "selectedValue": this.selectedValue

  }
     
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>() 
  @ViewChild('t1Sort') t1Sort: MatSort;
    
             
  
  dataSubject = new BehaviorSubject<any[]>([]) 
  
  displayedColumns: string[] = ['Ttsl_Ref_No','Ttsl_ID','Ttsl_UserName', 'Ttsl_EmailID', 'Ttsl_MobileNo', 'Ttsl_Department',   'Ttsl_Designation','Attachment','Create_Date','Ttsl_RegistrarRole','Approve','Reject'];     
            
         
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE)  
  deactivate=[];   
    entity2: any;  
    entity1: any;  
  Reg_Role: any;
  regRole: any;  
  approvedProcessRoles:any;
  processRolesSplitted:any

  Role:any;
  form1: any = {};
  form2: any = {};

  UrnFromURL: any;
  constructor(
   // private imp: APIImportPreferenceService,
    private es: APIEntityService,
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,    
    private router: Router) {
      this._route.params.subscribe((params) => {
        this.UrnFromURL = params['urn'];
      }) 

    }

  ngOnInit() {
    this.ProcessRole = this.db.get(Constants.SESSSION_STORAGE, Constants.Ttsl_ProcessRole)
var parsedRoles=JSON.parse(this.ProcessRole)
  this.approvedProcessRoles= Object.keys(parsedRoles).filter(key=>parsedRoles[key]=="A");  //Approved ProcessRoles of the logged-in Process Owner
if(this.approvedProcessRoles.includes("100"))
this.displayedColumns= ['Ttsl_Ref_No','Ttsl_ID','Ttsl_UserName', 'Ttsl_EmailID', 'Ttsl_MobileNo', 'Ttsl_Department',   'Ttsl_Designation','Attachment','Create_Date','Ttsl_RegistrarRole','Approve','Reject'];
else
this.displayedColumns= ['Ttsl_Ref_No','Ttsl_ID','Ttsl_UserName', 'Ttsl_EmailID', 'Ttsl_MobileNo', 'Ttsl_Department',   'Ttsl_Designation','Create_Date','Ttsl_RegistrarRole','Approve','Reject'];

    this.APIgetEntitySummary()
   
    this.modelTest = this.$modal;
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.maxDate.setDate(new Date().getDate());

  }

 unsorted(){
   return 0;
 }

  downloadcsvfile(){     
    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530')
    this.data.selectedValue=this.selectedValue
    this.es.downloadentitycsvfile(this.data).subscribe(r => {  
   
      fileName = currentdat+ ' Search Records.csv';
   
  
    importedSaveAs(r, fileName)
    //  this.downloadFile(r, Batch_Id)     
      this.$modal.successModal({
        title: 'TTSL Worklist',
        msg: 'File has been downloaded Successfully'
      })   
    })
  }  

  

  reset(){
    this.form1={}

    this.data= {
    
      "ProcessRole": this.ProcessRole,
      "status":"C",
      "selectedValue":this.selectedValue

    }
    this.APIgetEntitySummary()
    console.log("first reset function")
  }



 
  // tataDialog(refNo,emailid,Reg_Role): void {
	// this.refNos= refNo;
  // this.ttlids= emailid;
  // this.Reg_Role=Reg_Role
	// const dialogRef = this.dialog.open(EntityDialogComponent, {
	// 	data: {}  
	//   })
	  
	//   dialogRef.afterClosed().subscribe((res) => {  
		  
	// 	  //console.log(comment,"****")
		  
	// 	  if(res.action == 'submit'){   
	// 		  this.rejectEntityComplaints(this.refNos,this.ttlids,res.data,this.Reg_Role)
	// 	  }
		  
  // })	  
  // }   

  getSubstring(newfilename) {    
    if(newfilename)
      return newfilename.substring(newfilename.indexOf('.') + 1)
    else 
      return
    }
  onSubmitFilter(filterForm){
    console.log(filterForm.value)
    console.log("hi !!!")
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    console.log(fdate)
    console.log(ldate)
    if(typeof fdate === 'undefined' || fdate == null )
      fdate ="";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530')
    if(typeof ldate === 'undefined' || ldate == null )
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530')
      var param = filterForm.search
      if(typeof param === 'undefined' || param == null )  
        param ="";
      else
        param = filterForm.search


        var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');
         if (fdate != "" && ldate == "") {
          ldate = cdate
        }
  
    const filterType = filterForm.searchBy;
    if((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || (filterForm.searchBy=="" || filterForm.searchBy==null && !filterForm.startDate)){
      this.$modal.errorModal({
        title: 'TTSL Worklist',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((filterType != null && filterType != "") && (param == null || param=="")) {

      this.$modal.errorModal({
        title: 'TTSL Worklist',
        msg: 'Please provide '+filterType+' value'
      });
    }
    else if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      this.$modal.errorModal({
        title: 'TTSL Worklist',
        msg: 'Please select any option'
      });
    }
    else if(fdate>ldate){
      this.$modal.errorModal({
        title: 'TTSL Worklist',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'TTSL Worklist',
        msg: 'Please select Start date'
      });
    }
   else {
     this.data = {
    
        "Start_Date": fdate,
        "End_Date":ldate,
        "filterType": filterType,    
        "param":param,
        "ProcessRole":this.ProcessRole,
        "status":"C",
        "selectedValue":this.selectedValue


      }

      this.es.getTtsluserSummaryFilter(this.data)
      .subscribe(r => {
  
  
       console.log("r"+r)
       console.log(JSON.stringify(r))
       let rr = JSON.stringify(r)
       console.log("r.Data"+r.Data)
       console.log("r.Data"+JSON.stringify(r.Data))
       this.fetchedData = JSON.stringify(r.Data)
       console.log("this.fetchedData"+this.fetchedData)
       console.log("ArrayData"+JSON.parse(this.fetchedData))
      this.dataSource = r.Data;
      this.onChangeDataSource(r.Data)
  
      })
    }
  }
  

  APIgetEntitySummary() {
   
     this.es.getTataSummaryMongo(this.ProcessRole ,"C",this.selectedValue)   
      .subscribe(r => {   
      
        this.entity = r;
        this.onChangeDataSource(this.entity)
      }) 
  }



  onChangebutton(event){
    this.form1={}

    
    
    if(event.value=="Registrar"){
      this.displayedColumns= ['Ttsl_Ref_No','Ttsl_ID','Ttsl_UserName', 'Ttsl_EmailID', 'Ttsl_MobileNo', 'Ttsl_Department',   'Ttsl_Designation','Create_Date','Ttsl_RegistrarRole','Approve','Reject'];
  this.selectedValue="Registrar"
  this.es.getTataSummaryMongo(this.ProcessRole ,"C",this.selectedValue)   
  .subscribe(r => {   
    this.onChangeDataSource(r)
  }) 

}
else if(event.value=="Process"){
  this.displayedColumns= ['Ttsl_Ref_No','Ttsl_ID','Ttsl_UserName', 'Ttsl_EmailID', 'Ttsl_MobileNo', 'Ttsl_Department',   'Ttsl_Designation','Create_Date','Attachment','Ttsl_RegistrarRole','Approve','Reject'];
  this.selectedValue="Process"
  this.es.getTataSummaryMongo(this.ProcessRole ,"C",this.selectedValue)   
  .subscribe(r => {   
    this.onChangeDataSource(r)
  }) 
}
else {


}


  }
  
  
  onChangeDataSource(value) {
    this.dataSource = new MatTableDataSource(value)
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0))
  }

  
 

 refresh(){
	 
  this.APIgetEntitySummary()
       
	 
 }

  approveTataUsers(Ttsl_Ref_No,role, roleId,emailId,mobileno): void {
    var data = {
		    "status": "A",
        "Approve_By": this.entityId,
        "Ttsl_Ref_No": Ttsl_Ref_No,
        "ProcessRole":this.ProcessRole,
        "roleId":roleId,
        "role":role,
        "emailId":emailId,
        "mobileno":mobileno

    } 
   this.es.updateTataSummaryforApproval(data)  
      .subscribe(r => {
          if (r.status == "success") {
          this.$modal.successModal({
            title: 'Success',
            msg: 'Request has been approved'
          })
     this.refresh()

        }
        else if (r.status == "Fail" && r.message=="Exists") {
          this.$modal.errorModal({
            title: 'Error',
            msg: 'Process Owner Already Exists for this process'
          })

        }
        else {
          this.$modal.errorModal({
            title: 'Error',
            msg: 'Some Error Occured'
          })
        }
      })
  }
 

  rejectTataUsers(Ttsl_Ref_No,role,roleId,emailId,mobileno): void {
    var data = {
     
        "status": "R",
        "Approve_By": this.entityId,
        "Ttsl_Ref_No": Ttsl_Ref_No,  
        "ProcessRole":this.ProcessRole,
        "roleId":roleId, 
        "role":role,
        "emailId":emailId,
        "mobileno":mobileno     
    };
       this.es.updateTataSummaryforApproval(data)   
      .subscribe(r => {
       
        if (r.status == "success") {
          this.$modal.errorModal({
            title: 'Success',
            msg: 'Request has been Rejected'
          })
		      this.refresh()   

        }
        else {
          this.$modal.errorModal({
            title: 'Error',
            msg: 'Some Error Occured'
          })
        }
     

      })
  }

  download(Ttsl_ID,filename){  
    var data = {
      "Ttsl_ID": Ttsl_ID,
      "FileType": "KYC",
      "FileName": filename
    } 

  this.es.downloadtatafile(data).subscribe(r => { 

   console.log("response --- : ",r) 
   
    this.downloadFile(r, filename)
    this.$modal.successModal({
      title: 'TTL Worklist',
      msg: 'File has been downloaded Successfully'
    })   
  })
  this.fileDownload = []; 
}

private downloadFile(res: any, filename: string): void {
  const url = window.URL.createObjectURL(res)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.setAttribute('style', 'display: none')
  a.href = url;
  a.download = filename;
  a.click()
  window.URL.revokeObjectURL(url)     
  a.remove()
}


}  



